/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface StationName
 */
export interface StationName {
    /**
     * 
     * @type {string}
     * @memberof StationName
     */
    newName: string;
}

export function StationNameFromJSON(json: any): StationName {
    return StationNameFromJSONTyped(json, false);
}

export function StationNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): StationName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newName': json['newName'],
    };
}

export function StationNameToJSON(value?: StationName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newName': value.newName,
    };
}


